import { Component } from "@angular/core";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    standalone: false
})
export class FooterComponent {
    readonly year = new Date().getFullYear();

    readonly socialLinks = [
        {
            label: "Facebook",
            url: "https://www.facebook.com/OSUFoodAgEnv",
            icon: "fa-brands fa-facebook-f",
        },
        {
            label: "Instagram",
            url: "https://www.instagram.com/osucfaes",
            icon: "fa-brands fa-instagram",
        },
        {
            label: "X",
            url: "https://twitter.com/CFAES_OSU",
            icon: "fa-brands fa-x-twitter",
        },
        {
            label: "LinkedIn",
            url: "https://www.linkedin.com/school/cfaes/",
            icon: "fa-brands fa-linkedin-in",
        },
        {
            label: "YouTube",
            url: "https://www.youtube.com/osucfaes",
            icon: "fa-brands fa-youtube",
        },
    ];
}
